import { Button, DatePicker, Drawer, Form, Row, Select, Space } from 'antd';
import React, { useState } from 'react';
import dayjs, { type Dayjs } from 'dayjs';
import filterIcon from '../../assets/Layout/filter.svg';

const { RangePicker } = DatePicker;

export type AssignmentFilterValues = {
    studentId?: number;
    lessonId?: number;
    startDueDate?: string;
    endDueDate?: string;
};

interface AssignmentFilterProps {
    filter: AssignmentFilterValues;
    lessons: any[];
    loading: boolean;
    onChangeFilter: (values: AssignmentFilterValues) => void;
    onOpen: () => Promise<void>;
    students: any[];
}

const Filter: React.FC<AssignmentFilterProps> = ({
    filter,
    lessons,
    loading,
    onChangeFilter,
    onOpen,
    students,
}) => {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();

    const setFormValues = () => {
        form.setFieldsValue({
            studentId: filter.studentId,
            lessonId: filter.lessonId,
            dueDateRange: filter.startDueDate && filter.endDueDate
                ? [dayjs(filter.startDueDate), dayjs(filter.endDueDate)]
                : undefined,
        });
    };

    const showDrawer = () => {
        setFormValues();
        setOpen(true);
        void onOpen();
    };

    const closeDrawer = () => {
        form.resetFields();
        setOpen(false);
    };

    const clearFilters = () => {
        form.resetFields();
        onChangeFilter({});
    };

    const applyFilters = (values: { studentId?: number; lessonId?: number; dueDateRange?: [Dayjs, Dayjs] }) => {
        const [startDueDate, endDueDate] = values.dueDateRange || [];
        onChangeFilter({
            studentId: values.studentId,
            lessonId: values.lessonId,
            startDueDate: startDueDate?.startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
            endDueDate: endDueDate?.endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        });
        setOpen(false);
    };

    return (
        <>
            <Button aria-label="Ödev filtrelerini aç" className="mr-15" onClick={showDrawer} type="default">
                <Row>
                    <img src={filterIcon} alt="Filtrele" style={{ margin: 1 }} />
                </Row>
            </Button>
            <Drawer
                title="Ödev Filtresi"
                placement="right"
                onClose={closeDrawer}
                open={open}
                footer={(
                    <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={closeDrawer}>Kapat</Button>
                        <Button onClick={clearFilters}>Temizle</Button>
                        <Button className="bg-saha-purple font-color-white" onClick={() => form.submit()} type="default">
                            Uygula
                        </Button>
                    </Space>
                )}
            >
                <Form form={form} layout="vertical" onFinish={applyFilters}>
                    <Form.Item label="Öğrenci" name="studentId">
                        <Select
                            allowClear
                            loading={loading}
                            optionFilterProp="label"
                            options={students.map((student: any) => ({
                                value: student.id,
                                label: `${student.firstName} ${student.lastName}`,
                            }))}
                            placeholder="Öğrenci seçin"
                            showSearch
                        />
                    </Form.Item>
                    <Form.Item label="Ders" name="lessonId">
                        <Select
                            allowClear
                            loading={loading}
                            optionFilterProp="label"
                            options={lessons.map((lesson: any) => ({ value: lesson.id, label: lesson.name }))}
                            placeholder="Ders seçin"
                            showSearch
                        />
                    </Form.Item>
                    <Form.Item label="Ödev Teslim Tarihi" name="dueDateRange">
                        <RangePicker className="w-full" format="DD/MM/YYYY" />
                    </Form.Item>
                </Form>
            </Drawer>
        </>
    );
};

export default Filter;
